export default "__VITE_ASSET__DJRvJlJC__"